import { STATUS_TYPE } from '../../../enum';

export interface ServiceCategory {
  id: string;
  labelEn: string;
  labelAr: string;
  image: string;
  position: string | number;
  activeState: boolean;
}

export interface FindServiceCategory {
  search?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePatchServiceCategory {
  id?: string;
  labelEn: string;
  labelAr: string;
  image: string;
  position: string;
  activeState: boolean;
}

interface InitialState {
  data: ServiceCategory[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
